import React, {PureComponent} from 'react';
import cn from 'classnames'
import {Helmet} from 'react-helmet'
import injectSheet from 'react-jss'
import {connect} from "react-redux"
import { NProgress } from 'redux-nprogress';

import {getMetadata, getLoadedTrending, getLoadingTrending, isShopTheLookOpen, isUsingUniversalMenu, getUserMetadata} from "../selectors"
import globalStyles from "../styles/global"

import Header from "./Header"
import Menu from "./Menu"
import PageContent from "./PageContent"
import theme from "../styles/theme"

import {googleTagManagerId} from "../config"
import GoogleTagManager from "./GoogleTagManager"
import { fetchTrendingRequest, fetchUserMetadataRequest } from "../actions";

import {getGlobalContent} from "../selectors/content";
import {SharedStructuredDataComponent} from "./StructuredDataComponent"
import ShopTheLookDialog from './ShopThLook/ShopTheLookDialog'
import GDPRPopup from './GDPR/GDPRPopup'

import PreviewLink from "./PreviewLink"

import Search from './Search'
import UniversalNav from "./UniversalNav"

export class App extends PureComponent {

    componentDidMount() {
        // NOT SURE ABOUT THIS, SHOULD I DO THIS ON THE SERVER?
        // Needs to be a separate request to global content as it is cached differently
        const {loadedTrending, loadingTrending, handleFetchTrending, handleFetchUserMetadata} = this.props;
        if(!loadedTrending && !loadingTrending)
            handleFetchTrending();

        handleFetchUserMetadata();
    }

    render() {
        const {meta, classes, global, universalMenu, userMetadata} = this.props;

        return (
            <div id="edition-app" className={classes.bodyContainer}>
                <GoogleTagManager gtmId={googleTagManagerId} />
                    {meta && <Helmet>
                        <title>{meta.title}</title>
                        {meta.ogUrl && <link rel="canonical" href={meta.ogUrl}/>}
                        {meta.meta_title && <meta name="title" content={meta.meta_title} />}
                        {meta.metaDescription && <meta name="description" content={meta.metaDescription}/>}
                        {meta.metaKeywords && <meta name="keywords" content={meta.metaKeywords}/>}
                        {meta.metaRobots && <meta name="robots" content={meta.metaRobots}/>}
                        {meta.ogUrl && <meta property="og:url" content={meta.ogUrl}/>}
                        {meta.ogTitle && <meta property="og:title" content={meta.ogTitle}/>}
                        {meta.ogImage && [
                            <meta property="og:image" content={meta.ogImage.url} key={0}/>,
                            <meta property="og:image:width" content={meta.ogImage.width} key={1}/>,
                            <meta property="og:image:height" content={meta.ogImage.height} key={2}/>,
                        ]}
                        {meta.ogType && <meta property="og:type" content={meta.ogType}/>}
                        {meta.ogPublishedDate && <meta property="article:published_time" content={meta.ogPublishedDate}/>}
                        {meta.ogDescription && <meta property="og:description" content={meta.ogDescription}/>}
                        {meta.ogSiteName && <meta property="og:site_name" content={meta.ogSiteName}/>}

                        {meta.ogImage && <meta name="twitter:card" content="summary_large_image"/>}
                        {meta.ogSiteName && <meta name="twitter:site" content={meta.ogSiteName}/>}
                        {meta.ogTitle && <meta name="twitter:title" content={meta.ogTitle}/>}
                        {meta.ogDescription && <meta name="twitter:description" content={meta.ogDescription}/>}
                        {meta.ogImage && <meta name="twitter:image" content={meta.ogImage.url}/>}
                    </Helmet>
                    }
                    <SharedStructuredDataComponent global={global} />
                    <div className={cn(classes.content)} id="container">
                        <NProgress color={theme.colors.primary} />
                        {universalMenu ?
                            <UniversalNav /> :
                            <Header />
                        }
                        <PageContent />
                    </div>
                    <GDPRPopup countryCode={userMetadata.countryCode} />
                    <Menu />
                    <ShopTheLookDialog />
                    <Search type='summary' />
                    <PreviewLink />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        meta: getMetadata(state),
        loadedTrending: getLoadedTrending(state),
        loadingTrending: getLoadingTrending(state),
        global: getGlobalContent(state),
        isShopTheLookOpen: isShopTheLookOpen(state),
        universalMenu: isUsingUniversalMenu(state),
        userMetadata: getUserMetadata(state)
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        handleFetchTrending: () => {
            dispatch( fetchTrendingRequest() );
        },
        handleFetchUserMetadata: () => {
            dispatch( fetchUserMetadataRequest() )
        }
    }
}

export const styleSheet = (theme) => (
    {
        ...globalStyles(theme),
        bodyContainer: {
            display: "flex",
            flexDirection: "column",
            minHeight: "100vh"
        },
        content: {
            flex: "1 0 auto",
        }
    }
);

export default injectSheet((theme) => styleSheet(theme))(connect(mapStateToProps, mapDispatchToProps)(App));



// WEBPACK FOOTER //
// ./src/components/App.js